import React, { useEffect } from "react";
import { DashboardView } from "../components/DashboardView";
import { AppLayout } from "../components/AppLayout";
import { useAuth } from "../helpers/useAuth";
import { Skeleton } from "../components/Skeleton";
import { Helmet } from "react-helmet";

export default function HomePage() {
  const { authState } = useAuth();
  const isAnonymous = authState.type !== "loading" && authState.type !== "authenticated";

  // L'accueil `/` est une page Twig servie par Symfony, que le routeur React ne
  // connaît pas : un Navigate vers `/` affichait la page 404 de l'application.
  // Un visiteur non connecté repart donc vers l'accueil par un vrai chargement.
  useEffect(() => {
    if (isAnonymous) window.location.replace("/");
  }, [isAnonymous]);

  // Helmet noindex appliqué dans TOUS les états (loading, anonyme, authentifié) :
  // /home/ est une page utilisateur privée, jamais à indexer. Avant ce fix,
  // PSI Google crawlait /home/ + détectait le window.location.href redirect
  // comme 2.5s de waste LCP. Maintenant : noindex strict.
  const noindex = (
    <Helmet>
      <title>Tableau de bord - KenoMetric</title>
      <meta name="robots" content="noindex" />
    </Helmet>
  );

  if (authState.type === "loading" || isAnonymous) {
    return (
      <>
        {noindex}
        <div style={{ padding: "var(--spacing-8)", maxWidth: 800, margin: "0 auto", width: "100%", display: "flex", flexDirection: "column", gap: "var(--spacing-4)" }}>
          <Skeleton style={{ height: 200 }} />
          <Skeleton style={{ height: 200, width: "80%" }} />
          <Skeleton style={{ height: 200, width: "60%" }} />
        </div>
      </>
    );
  }

  return (
    <AppLayout>
      <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        {noindex}
        <DashboardView />
      </div>
    </AppLayout>
  );
}
